module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setting"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "setBox"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("系统设置")]), _vm._v(" "), _c('div', {
    staticClass: "setItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("是否开启系统网费开关：")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.customSwitch),
      callback: function($$v) {
        _vm.customSwitch = $$v
      },
      expression: "customSwitch"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.customSwitch),
      callback: function($$v) {
        _vm.customSwitch = $$v
      },
      expression: "customSwitch"
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('span', {
    staticClass: "left tip"
  }, [_vm._v("（推荐网吧开启）")])], 1), _vm._v(" "), _c('div', {
    staticClass: "setItem clearfix"
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("是否开启退单授权密码验证：")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.refundSwitch),
      callback: function($$v) {
        _vm.refundSwitch = $$v
      },
      expression: "refundSwitch"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.refundSwitch),
      callback: function($$v) {
        _vm.refundSwitch = $$v
      },
      expression: "refundSwitch"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "setItem clearfix",
    staticStyle: {
      "height": "36px",
      "line-height": "36px"
    }
  }, [_c('span', {
    staticClass: "left itemName"
  }, [_vm._v("新增会员派发优惠券：")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.couponSwitch),
      callback: function($$v) {
        _vm.couponSwitch = $$v
      },
      expression: "couponSwitch"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.couponSwitch),
      callback: function($$v) {
        _vm.couponSwitch = $$v
      },
      expression: "couponSwitch"
    }
  }, [_vm._v("否")]), _vm._v(" "), (_vm.couponSwitch == 'ON') ? _c('el-select', {
    staticClass: "left",
    staticStyle: {
      "margin-left": "10px"
    },
    model: {
      value: (_vm.couponModel),
      callback: function($$v) {
        _vm.couponModel = $$v
      },
      expression: "couponModel"
    }
  }, [_vm._l((_vm.couponList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.title,
        "value": JSON.stringify(item)
      }
    })
  }), _vm._v(" "), (_vm.couponListMoreBtn) ? _c('li', {
    staticStyle: {
      "color": "#999",
      "padding": "10px 0",
      "text-align": "center",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_c('span', [_vm._v("更多优惠券...")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.couponSwitch == 'ON') ? _c('p', {
    staticClass: "left",
    staticStyle: {
      "color": "#fff",
      "text-align": "center",
      "cursor": "pointer",
      "margin-left": "20px",
      "background-color": "#3068ff",
      "width": "80px",
      "border-radius": "20px"
    },
    on: {
      "click": _vm.configCoupon
    }
  }, [_vm._v("提交")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("店铺设置")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("店铺名称：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.name),
      expression: "newStore.name"
    }],
    staticClass: "left",
    attrs: {
      "type": "text",
      "placeholder": "请输入店铺名"
    },
    domProps: {
      "value": (_vm.newStore.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("店铺类型：")]), _vm._v(" "), _c('el-select', {
    staticClass: "left",
    attrs: {
      "placeholder": "请选择店铺类型"
    },
    model: {
      value: (_vm.newStore.typeId),
      callback: function($$v) {
        _vm.$set(_vm.newStore, "typeId", $$v)
      },
      expression: "newStore.typeId"
    }
  }, _vm._l((_vm.storeType), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("店铺地址：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newStore.addr),
      expression: "newStore.addr"
    }],
    staticClass: "left",
    attrs: {
      "type": "text",
      "placeholder": "请输入地址"
    },
    domProps: {
      "value": (_vm.newStore.addr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newStore, "addr", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveStore
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("呼叫设置")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("呼叫热栏信息标题：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hotTitle),
      expression: "hotTitle"
    }],
    staticClass: "left",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入...(如近期热销、最近更新、等等...)"
    },
    domProps: {
      "value": (_vm.hotTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hotTitle = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("呼叫滚动信息标题：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rollTitle),
      expression: "rollTitle"
    }],
    staticClass: "left",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "text",
      "placeholder": "（默认为打赏排名）请输入...(如网吧公告，等...)"
    },
    domProps: {
      "value": (_vm.rollTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rollTitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v("*修改为打赏排名将展示打赏排名信息")])]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix desc"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("呼叫滚动信息：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rollNotice),
      expression: "rollNotice"
    }],
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": "请输入呼叫滚动信息..."
    },
    domProps: {
      "value": (_vm.rollNotice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rollNotice = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix desc"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("店铺简介：")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.summary),
      expression: "summary"
    }],
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10",
      "placeholder": "请输入店铺简介..."
    },
    domProps: {
      "value": (_vm.summary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.summary = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix logo"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("店铺logo：")]), _vm._v(" "), (_vm.logoUrl) ? _c('img', {
    attrs: {
      "src": _vm.logoUrl,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "logoUrl",
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'logo')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v("*请裁剪为正方形")])]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix logo"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("店铺二维码：")]), _vm._v(" "), (_vm.storeQrCode) ? _c('img', {
    attrs: {
      "src": _vm.storeQrCode,
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "storeQrCode",
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": function($event) {
        return _vm.coverImg($event, 'storeQrCode')
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "red",
      "font-size": "12px"
    }
  }, [_vm._v("*店铺联系人二维码(此二维码将展示在呼叫客户端)")])]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveCallInfo
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("会员充值设置")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("会员充值最低限额：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.limitRechargeMoney),
      expression: "limitRechargeMoney"
    }],
    staticClass: "left",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "text",
      "placeholder": "请输入金额"
    },
    domProps: {
      "value": (_vm.limitRechargeMoney)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.limitRechargeMoney = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveLimit
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("店铺是否开启配送员")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.deliveryEnabled),
      callback: function($$v) {
        _vm.deliveryEnabled = $$v
      },
      expression: "deliveryEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.deliveryEnabled),
      callback: function($$v) {
        _vm.deliveryEnabled = $$v
      },
      expression: "deliveryEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.deliveryEnabled) ? _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("原有提成的占比：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalRate),
      expression: "globalRate"
    }],
    staticClass: "left",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "min": "0",
      "max": "100",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.globalRate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.globalRate = $event.target.value
      }
    }
  }), _vm._v("%\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveDelivery
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("客户端是否开启会员支付")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.memberEnabled),
      callback: function($$v) {
        _vm.memberEnabled = $$v
      },
      expression: "memberEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.memberEnabled),
      callback: function($$v) {
        _vm.memberEnabled = $$v
      },
      expression: "memberEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveMem
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("授权密码设置")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('div', {
    staticClass: "left itemName"
  }, [_vm._v("密码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discountPwd),
      expression: "discountPwd"
    }],
    staticClass: "left",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.discountPwd)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discountPwd = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.savePwd
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("是否允许PC点单")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.pcOrderEnabled),
      callback: function($$v) {
        _vm.pcOrderEnabled = $$v
      },
      expression: "pcOrderEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.pcOrderEnabled),
      callback: function($$v) {
        _vm.pcOrderEnabled = $$v
      },
      expression: "pcOrderEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.savePcOrderEnabled
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("是否开启音频设备选择")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.voiceEnabled),
      callback: function($$v) {
        _vm.voiceEnabled = $$v
      },
      expression: "voiceEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.voiceEnabled),
      callback: function($$v) {
        _vm.voiceEnabled = $$v
      },
      expression: "voiceEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveIsOpenVoiceSel
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("是否开启租赁设备归还语音播报")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.returnCallEnabled),
      callback: function($$v) {
        _vm.returnCallEnabled = $$v
      },
      expression: "returnCallEnabled"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.returnCallEnabled),
      callback: function($$v) {
        _vm.returnCallEnabled = $$v
      },
      expression: "returnCallEnabled"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveReturnCallEnabled
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("是否开启交班预打印小票")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "ON"
    },
    model: {
      value: (_vm.isOpenPrevPrint),
      callback: function($$v) {
        _vm.isOpenPrevPrint = $$v
      },
      expression: "isOpenPrevPrint"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": "OFF"
    },
    model: {
      value: (_vm.isOpenPrevPrint),
      callback: function($$v) {
        _vm.isOpenPrevPrint = $$v
      },
      expression: "isOpenPrevPrint"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveIsOpenPrevPrint
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("是否允许收银端下架商品")]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.allowProductCancelSale),
      callback: function($$v) {
        _vm.allowProductCancelSale = $$v
      },
      expression: "allowProductCancelSale"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio left itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.allowProductCancelSale),
      callback: function($$v) {
        _vm.allowProductCancelSale = $$v
      },
      expression: "allowProductCancelSale"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveAllowProductCancelSale
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("厨房打印机IP设置"), _c('button', {
    staticClass: "add-more",
    on: {
      "click": function($event) {
        return _vm.printEr.push({
          id: '',
          name: '',
          ipAddress: '',
          port: ''
        })
      }
    }
  }, [_vm._v("添加更多打印机")])]), _vm._v(" "), _vm._l((_vm.printEr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "setItem_1 clearfix"
    }, [_c('div', {
      staticClass: "left itemName"
    }, [_vm._v("打印机名字:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.name),
        expression: "item.name"
      }],
      staticClass: "left",
      staticStyle: {
        "width": "120px",
        "text-align": "center",
        "padding-left": "0"
      },
      attrs: {
        "type": "text",
        "placeholder": "自定义打印机名字"
      },
      domProps: {
        "value": (item.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "name", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "left itemName"
    }, [_vm._v(" IP地址:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.ipAddress),
        expression: "item.ipAddress"
      }],
      staticClass: "left",
      staticStyle: {
        "width": "120px",
        "text-align": "center",
        "padding-left": "0"
      },
      attrs: {
        "type": "text",
        "placeholder": "请输入IP地址"
      },
      domProps: {
        "value": (item.ipAddress)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "ipAddress", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "left itemName"
    }, [_vm._v(" 端口号:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.port),
        expression: "item.port"
      }],
      staticClass: "left",
      staticStyle: {
        "width": "120px",
        "text-align": "center",
        "padding-left": "0"
      },
      attrs: {
        "type": "text",
        "placeholder": "请输入端口号"
      },
      domProps: {
        "value": (item.port)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "port", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticStyle: {
        "margin-left": "15px"
      },
      on: {
        "click": function($event) {
          return _vm.savePrintEr(item)
        }
      }
    }, [_vm._v("保存")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          return _vm.delPrintEr(item, index)
        }
      }
    }, [_vm._v("删除")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("点单备注信息设置"), _c('button', {
    staticClass: "add-more",
    on: {
      "click": function($event) {
        return _vm.notesArr.push({
          id: '',
          message: ''
        })
      }
    }
  }, [_vm._v("添加更多备注")])]), _vm._v(" "), _vm._l((_vm.notesArr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "setItem_1 clearfix"
    }, [_c('div', {
      staticClass: "left itemName"
    }, [_vm._v("内容:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.message),
        expression: "item.message"
      }],
      staticClass: "left",
      staticStyle: {
        "width": "350px",
        "text-align": "left",
        "padding-left": "0"
      },
      attrs: {
        "type": "text",
        "placeholder": "请填写备注内容..."
      },
      domProps: {
        "value": (item.message)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "message", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      staticStyle: {
        "margin-left": "15px"
      },
      on: {
        "click": function($event) {
          return _vm.saveNotes(item)
        }
      }
    }, [_vm._v("保存")]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          return _vm.delNotes(item)
        }
      }
    }, [_vm._v("删除")])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "setItemBox"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("机位预订时间设置"), _c('button', {
    staticClass: "add-more",
    on: {
      "click": function($event) {
        return _vm.timeArr.push({
          id: '',
          m: ''
        })
      }
    }
  }, [_vm._v("添加更多时间")])]), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_vm._v("\n                        是否开启店员宝机位预订\n                        "), _c('el-radio', {
    staticClass: "radio itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.dateOpen),
      callback: function($$v) {
        _vm.dateOpen = $$v
      },
      expression: "dateOpen"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.dateOpen),
      callback: function($$v) {
        _vm.dateOpen = $$v
      },
      expression: "dateOpen"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_vm._v("\n                        是否开启下机播报\n                        "), _c('el-radio', {
    staticClass: "radio itemRadio",
    attrs: {
      "label": true
    },
    model: {
      value: (_vm.voiceNotify),
      callback: function($$v) {
        _vm.voiceNotify = $$v
      },
      expression: "voiceNotify"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio itemRadio",
    attrs: {
      "label": false
    },
    model: {
      value: (_vm.voiceNotify),
      callback: function($$v) {
        _vm.voiceNotify = $$v
      },
      expression: "voiceNotify"
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.voiceNotify) ? _c('div', {
    staticClass: "setItem_1 clearfix"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.frontMessage),
      expression: "frontMessage"
    }],
    staticClass: "left",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "自定义内容..."
    },
    domProps: {
      "value": (_vm.frontMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.frontMessage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left itemName"
  }, [_vm._v("**号机已下机")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.backMessage),
      expression: "backMessage"
    }],
    staticClass: "left",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "text",
      "placeholder": "自定义内容..."
    },
    domProps: {
      "value": (_vm.backMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.backMessage = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.timeArr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "setItem_1 clearfix"
    }, [_c('div', {
      staticClass: "left itemName"
    }, [_vm._v("时间（分钟）:")]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.m),
        expression: "item.m"
      }],
      staticClass: "left",
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "type": "number",
        "placeholder": "请填写时间（分钟）..."
      },
      domProps: {
        "value": (item.m)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "m", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          return _vm.delTime(index)
        }
      }
    }, [_vm._v("删除")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "btnGroup"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.saveTime
    }
  }, [_vm._v("保存")])])], 2)])])]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.infoload),
      expression: "infoload",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "codes",
    attrs: {
      "title": '验证码',
      "visible": _vm.codeBtn,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.codeBtn = $event
      },
      "close": _vm.closeDialog
    }
  }, [(!_vm.isSendCodeBtn) ? _c('div', {
    staticStyle: {
      "color": "red",
      "margin-top": "10px",
      "font-size": "12px",
      "text-align": "center",
      "position": "absolute",
      "top": "8px",
      "left": "7em"
    }
  }, [_c('span', [_vm._v("验证码已发送到老板手机号")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inners"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isSendCodeBtn) ? _c('span', {
    staticClass: "sendcode",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v("发送验证码")]) : _vm._e(), _vm._v(" "), (!_vm.isSendCodeBtn) ? _c('span', {
    staticClass: "times",
    domProps: {
      "textContent": _vm._s(_vm.isSendCodeTimer + 's')
    }
  }) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.codeBtn = false;
        _vm.code = '';
        _vm.initBtn4 = true;
        _vm.isCancle = true
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.codeFn
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), (_vm.showCrop) ? _c('img-crop', {
    attrs: {
      "oldImg": _vm.oldImgBase64,
      "curCropW": _vm.curCropW,
      "curCropH": _vm.curCropH,
      "curStoreId": _vm.curStoreId
    },
    on: {
      "closeImgCrop": function($event) {
        _vm.showCrop = false
      },
      "getCropImgBase": _vm.getCropImgBase
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-6b46eef4","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/setting/setting.vue
// module id = 958
// module chunks = 1